<template>
    <div ref="menu"></div>
</template>

<script>
import Menu from "!!raw-loader!../../assets/ricoh_assets/icons/ICN003-05_menu.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.menu.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = Menu

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>

</style>